import { 
  SHOW_MODAL, 
  HIDE_MODAL,
  SET_MODAL_DATA
} from "../actions/noArticleModal";

export default function noArticleModal(state = {
  showModal: false,
  missingArticles: null,
  fileUrl: null,
  email: null
}, action) {
  switch (action.type) {
    case HIDE_MODAL:
      return {
        ...state,
        showModal: false
      };
    case SHOW_MODAL:
      return {
        ...state,
        showModal: true
      };
    case SET_MODAL_DATA:
      return {
        ...state,
        showModal: true,
        missingArticles: action.payload.missingArticles,
        fileUrl: action.payload.fileUrl
      };
    default:
      return state;
  }
}